import React from "react";

const FetchLoadingState = ({
  message = "Loading...",
  className = "",
  fullScreen = false,
}) => (
  <div
    className={`${fullScreen ? "min-h-screen" : "min-h-[260px]"} flex w-full flex-col items-center justify-center gap-5 px-5 py-10 text-center ${className}`}
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <span className="relative block h-20 w-20" aria-hidden="true">
      <span className="absolute inset-0 animate-spin rounded-full bg-[conic-gradient(from_0deg,#1233CC,#00BAFF,#1233CC,transparent_82%)] motion-reduce:animate-none" />
      <span className="absolute inset-[7px] rounded-full bg-[#FAFAFA] shadow-inner" />
      <span className="absolute inset-[27px] rounded-full bg-gradient-to-br from-[#1233CC] to-[#00BAFF] shadow-[0_0_18px_rgba(0,186,255,0.35)]" />
    </span>
    <div>
      <p className="text-base font-semibold text-[#071C50]">{message}</p>
      <p className="mt-1 text-xs text-slate-400">Please wait a moment</p>
    </div>
  </div>
);

export default FetchLoadingState;
